// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Edit2 as RawEdit2 } from "lucide-react";
export const Edit2 = /* @__PURE__ */ createIcon(RawEdit2, "Edit2", 2);
